module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.12423/images/template.svg"